import Shimmer from "./Shimmer";
import {useParams} from "react-router";
import useRestaurantMenu from "../utils/useRestaurantMenu";
import RestaurantCategory from "./RestaurantCategory";
import { useState } from "react";


const RestuarantMenu = () => {


    
    // const [resInfo, setResInfo] = useState(null);

    const {resId} = useParams();

//useRestaurantMenu is our custom hook and we are going to perform the fetching of the data
    const resInfo = useRestaurantMenu(resId);

    const [showIndex, setShowIndex] = useState(null);

    // console.log(resId);
/*
    useEffect(() => {
        fetchMenu ();
    }, []);

    const fetchMenu = async () => {
        const data = await fetch( MENU_API + resId);
       
        const json = await data.json();

        console.log(json);
        setResInfo(json.data);
    }
*/
    if(resInfo === null) return <Shimmer />;

    const {name, cuisines, costForTwoMessage} = resInfo?.cards[2]?.card?.card?.info;

    const {itemCards} = resInfo?.cards[4]?.groupedCard?.cardGroupMap?.REGULAR?.cards[1]?.card?.card;

    // console.log(itemCards);
    

    const categories =
    resInfo?.cards[4]?.groupedCard?.cardGroupMap?.REGULAR?.cards.filter(
      (c) =>
        c.card?.["card"]?.["@type"] ===
        "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory"
    );
  console.log(categories);


    return (
        <div className = "max-w-4xl mx-auto p-4">
            <h1 className="font-bold text-4xl text-gray-800 my-4">{name}</h1>
            <p className="text-lg text-gray-600 mb-8">{cuisines.join(",")} - {costForTwoMessage}</p>
          
            {/* categories accordions */}
            <div className="space-y-6">
        {categories.map((category, index) => (
            
            // controlled component
            <div
            key={category?.card?.card.title}
            className="bg-white shadow-md rounded-lg p-4 hover:shadow-xl transition-shadow duration-300"
            >
            <RestaurantCategory
            
            data={category?.card?.card}
            showItems={(index === showIndex) ? true : false}
            setShowIndex={() => setShowIndex(index === showIndex ? null : index)}
            // dummy={dummy}
            />
            </div>
        ))}
        </div>
        </div>
    )
}

export default RestuarantMenu;